import React, { useEffect, useState } from "react";
import axios from "axios";
import { shallow } from "zustand/shallow";

import UnverifiedItems from "./UnverifiedItems";
import useAppStore from "@components/Microsite/microsite-store";

export default function DashboardUnverified({ setView, children }) {
  const {
    coords,
    location,
    setAppLoading,
    user,
    verificationCode,
    entityInfo,
  } = useAppStore(
    (state) => ({
      coords: state.coords,
      location: state.location,
      setAppLoading: state.setAppLoading,
      user: state.user,
      verificationCode: state.verificationCode,
      entityInfo: state.entityInfo,
    }),
    shallow
  );
  const [unverifiedReadings, setUnverifiedReadings] = useState([]);
  const isVehicleDataEffort = entityInfo.is_vehicle_data_effort;

  useEffect(() => {
    fetchUnverified();
  }, []);

  function fetchUnverified() {
    const req = {
      ...coords,
      campaign_effort_id: entityInfo.campaign_effort_id,
      location_id: location?.id,
      user_id: user.id,
    };

    setAppLoading(true);

    axios
      .post(`/ride-challenge/retrieve-unverified-readings/`, req)
      .then(({ data }) => {
        if (!data.response.length) {
          setAppLoading(false);
          setView();
        } else {
          setUnverifiedReadings(data.response);
          setAppLoading(false);
        }
      })
      .catch((err) => {
        setUnverifiedReadings([]);
        setAppLoading(false);
      });
  }

  return (
    <div>
      <UnverifiedItems
        additionalReqData={{
          ...coords,
          campaign_effort_id: entityInfo.campaign_effort_id,
          location_id: location?.id,
        }}
        items={unverifiedReadings}
        // items={
        //   dashboardData &&
        //   dashboardData.unverified_data.map((m) => ({
        //     ...m,
        //     user_vehicle: foundEffort.user_vehicles.find(
        //       (f) => f.id === m.user_vehicle_id
        //     ),
        //   }))
        // }
        fetchData={() => {
          fetchUnverified();
        }}
        verificationCode={verificationCode}
        codeVerificationData={{
          ...coords,
          user_id: user?.id,
          user_location_id: user?.user_location_id,
          campaign_effort_id: entityInfo.campaign_effort_id,
          location_id: location?.id,
        }}
        isVehicleDataEffort={isVehicleDataEffort}
      >
        {children}
      </UnverifiedItems>
    </div>
  );
}
